/**
 * NoteUpdatesCtrl controller
 * Add/Edit Subscriber's note
 */
import { NOTE_SUB_TYPES, NOTE_TYPES } from '../../app/core/constants'

/**
 * NoteUpdatesCtrl controller
 *
 * @class NoteUpdatesCtrl
 * @memberof mwApp/subscribers
 * @see mwApp/subscribers
 *
 * @ngdoc controller
 * @name mwApp/subscribers.controller:NoteUpdatesCtrl
 */

/* @ngInject */
export default function NoteUpdatesCtrl ($uibModalInstance, NoteUpdates, AccessoryNoteUpdates, noteId, subscriberId, type) {
  const vm = this

  vm.fieldKyes = {
    description: 'Description',
    subject: 'Subject',
    issueObject: 'Issue Object',
    type: 'Type',
    Description: 'Description',
    Status: 'Status'
  }

  vm.properties = {
    issueObject: NOTE_SUB_TYPES,
    type: NOTE_TYPES
  }

  vm.noteUpdates = []

  vm.getNoteUpdates = function (tableState) {
    if (type === 'accessory') {
      tableState.search.predicateObject = { 'accessory-note-id': noteId, 'operation-type-id': 'UPDATE' }
    }
    (type === 'general' ? NoteUpdates : AccessoryNoteUpdates).loadSmart(tableState, { subscriberId, noteId })
      .then(data => {
        vm.noteUpdates = data.content
      })
  }

  vm.cancel = function () {
    $uibModalInstance.dismiss('cancel')
  }
}
